import { render, staticRenderFns } from "./point-list-01.vue?vue&type=template&id=f854952a&"
import script from "./point-list-01.vue?vue&type=script&lang=js&"
export * from "./point-list-01.vue?vue&type=script&lang=js&"
import style0 from "./point-list-01.vue?vue&type=style&index=0&id=f854952a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports